import { Directive, InjectionToken } from '@angular/core';

export const KT_PORTLET_TOOLS = new InjectionToken<KtPortletTools>('KtPortletTools');

@Directive({
	selector: 'ktPortletTools,[ktPortletTools]',
	providers: [{ provide: KT_PORTLET_TOOLS, useExisting: KtPortletTools }],
})
export class KtPortletTools {}
